/**
 * Is owner self-signup actually switched on for this environment?
 *
 * `/owners/signup` is gated server-side by
 * `platform_settings.owner_self_signup_enabled`; with it off the page answers
 * "Noch nicht verfügbar". Every public entry point into that page therefore has
 * to ask first — a marketing page that advertises a free account and then
 * refuses you is worse than one that never offered it.
 *
 * Returns `null` while the answer is still in flight, so callers can choose
 * between hiding until it is a definite yes (the free-tier CTA) and falling
 * back to their previous behaviour (the pricing cards' demo-call pop-up).
 *
 * Fails closed: an RPC error counts as "off".
 */
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export function useOwnerSelfSignupEnabled(): boolean | null {
  const [enabled, setEnabled] = useState<boolean | null>(null);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      const { data, error } = await (
        supabase as unknown as {
          rpc: (fn: string) => Promise<{ data: unknown; error: unknown }>;
        }
      ).rpc("owner_self_signup_enabled");
      if (!cancelled) setEnabled(!error && data === true);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return enabled;
}
